import { Link } from "react-router-dom";
import { ArrowRight, Bookmark, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { COMPARE_MAX } from "@/lib/compareSelection";

// View course · Add to shortlist · Compare course, for one Quick Check result row.
export function RowActions({ r, rowId, shortlisted, shortlistBusy, onToggleShortlist, compared, compareFull, onToggleCompare }) {
  const hasCourse = Boolean(r.degree_id);
  const name = r.degree_name ? `${r.degree_name} at ${r.university_name}` : r.university_name;
  const blocked = compareFull && !compared;
  return (
    <div data-testid={`row-actions-${rowId}`} className="basis-full flex flex-wrap items-center gap-2 border-t border-stone-100 pt-3">
      {hasCourse && (
        <Button asChild variant="outline" size="sm">
          <Link to={`/degree/${r.degree_id}`} data-testid={`row-view-course-${rowId}`} aria-label={`View course: ${name}`}>
            View course <ArrowRight className="h-3.5 w-3.5 ml-1.5" aria-hidden="true" />
          </Link>
        </Button>
      )}
      <Button
        type="button" variant="outline" size="sm"
        data-testid={`row-shortlist-${rowId}`}
        aria-pressed={shortlisted}
        aria-label={shortlisted ? `Remove ${name} from your shortlist` : `Add ${name} to your shortlist`}
        disabled={shortlistBusy}
        onClick={onToggleShortlist}
        className={shortlisted ? "border-emerald-300 bg-emerald-50 text-emerald-800 hover:bg-emerald-100" : ""}
      >
        {shortlistBusy ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" aria-hidden="true" />
          : shortlisted ? <Check className="h-3.5 w-3.5 mr-1.5" aria-hidden="true" />
            : <Bookmark className="h-3.5 w-3.5 mr-1.5" aria-hidden="true" />}
        {shortlisted ? "Shortlisted · remove" : "Add to shortlist"}
      </Button>
      {hasCourse && (
        <div className="inline-flex items-center gap-2 rounded-md px-2 py-1">
          <Checkbox
            id={`compare-${rowId}`}
            data-testid={`row-compare-${rowId}`}
            checked={compared}
            disabled={blocked}
            onCheckedChange={onToggleCompare}
            aria-describedby={blocked ? `compare-max-${rowId}` : undefined}
            className="border-stone-400 data-[state=checked]:bg-[#4C1D95] data-[state=checked]:border-[#4C1D95]"
          />
          <label htmlFor={`compare-${rowId}`} className={`text-sm ${blocked ? "text-stone-400" : "text-stone-700 cursor-pointer"}`}>
            Compare course
          </label>
          {blocked && (
            <span id={`compare-max-${rowId}`} data-testid={`row-compare-max-${rowId}`} className="text-[11px] text-stone-500">
              Up to {COMPARE_MAX} at once
            </span>
          )}
        </div>
      )}
    </div>
  );
}
